import ServiceBase from "@app/shared/serviceBase";

/** Handles retrieval operations for support information. */
export default class TutorialsService extends ServiceBase {

  /**
     * Retrieves a tutorial file URI from blob storage.
     * @param containerReference The container.
     * @param containerItem The container item.
     * @param itemExtension The container item's extension.
     */
  public async getBlobSasUri(containerReference: string, containerItem: string, itemExtension: string): Promise<string> {
    return await this.makeGet<string>(`tutorial/${containerReference}/${containerItem}/${itemExtension}`);
  }
  
  public async updateBlobSas(containerReference: string, containerItem: string, itemExtension: string, rowTitle: string, file?: FormData): Promise<string> {
    return await this.makePost<string>(`tutorial/file/${containerReference}/${containerItem}/${itemExtension}/${rowTitle}`, file, undefined, true, false, false);
  }

  public async updateHyperlinkBlobSas(containerReference: string, rowTitle: string, hyperlinkURL?: string, index?: number): Promise<string> {
    return await this.makePost<string>(`tutorial/hyperlink/${containerReference}/${rowTitle}${index != null ? `?index=${index}` : ""}`, hyperlinkURL);
  }

  public async deleteBlobSas(containerReference: string, containerItem: string, itemExtension: string): Promise<string> {
    return await this.makeDelete<string>(`tutorial/delete/${containerReference}/${containerItem}/${itemExtension}`);
  }

  public async showBlobSas(containerReference: string): Promise<string> {
    return await this.makeGet<string>(`tutorial/show/${containerReference}`);
  }

}